module.exports = __webpack_public_path__ + "static/media/fireplace.bdb95d2c.svg";